import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import ViewSettings from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/view-settings';
import FilterBar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/filter-bar';
import PageHeader from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header';
import Search from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/search';
import ViewModeSwitcher from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/view-mode-switcher';
import Scenarios from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/title-bar/scenarios';
import Warnings from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/title-bar/warnings';
import { DEPENDENCY_REPORT_SHARE_TYPE } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export const Header = ({ confluenceMacroType }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<div
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={
				confluenceMacroType === DEPENDENCY_REPORT_SHARE_TYPE ? styles.header : styles.borderHeader
			}
		>
			<PageHeader
				title={
					confluenceMacroType === DEPENDENCY_REPORT_SHARE_TYPE
						? formatMessage(messages.dependencies)
						: undefined
				}
				titleDecorators={
					confluenceMacroType !== DEPENDENCY_REPORT_SHARE_TYPE && (
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						<div className={styles.actionWrapper}>
							<Scenarios />
							<Search />
							<FilterBar />
						</div>
					)
				}
				actions={
					confluenceMacroType !== DEPENDENCY_REPORT_SHARE_TYPE && (
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						<div className={styles.actionWrapper}>
							<Warnings />
							<ViewModeSwitcher />
							<ViewSettings />
						</div>
					)
				}
				showPlanTitle
				withBreadcrumbs={false}
			/>
		</div>
	);
};
